const CategoryActions = {
    UPDATE: 'UPDATE_CATEGORIES',
}

export default CategoryActions;